import { buildScopedI18n } from '../../../../utils/buildScopedI18n';
import rolesEsCL from './locales/es-CL.json';
import rolesEnUS from './locales/en-US.json';
import rolesPtBR from './locales/pt-BR.json';

export const rolesI18n = buildScopedI18n({
  esCL: rolesEsCL,
  enUS: rolesEnUS,
  ptBR: rolesPtBR,
});
